interface BrandMarkProps {
  inverted?: boolean;
  size?: number;
}

export function BrandMark({ inverted = false, size = 26 }: BrandMarkProps) {
  return (
    <span
      className={`relative inline-flex items-center justify-center rounded-[7px] font-display font-extrabold overflow-hidden ${
        inverted ? 'bg-white text-ink-900' : 'bg-ink-900 text-white'
      }`}
      style={{ width: size, height: size, fontSize: size * 0.55 }}
      aria-hidden="true"
    >
      M
      <span
        className="absolute rounded-full bg-saffron-500"
        style={{
          width: size * 0.46,
          height: size * 0.46,
          right: -size * 0.15,
          bottom: -size * 0.15,
        }}
      />
    </span>
  );
}
